const NAVIGATION_CODE = {
    generation: 'report-pv-generation',
    battery: 'report-battery',
    'appliance-chart': 'home-appliance-chart',
};
const excludeGenerationReport = (navigation) => {
    return navigation.filter((nav) => nav.code !== NAVIGATION_CODE.generation);
};
const excludeBatteryReport = (navigation) => {
    return navigation.filter((nav) => nav.code !== NAVIGATION_CODE.battery);
};
const getFilteredReport = (navigation, hasPV, hasESS, isConsumptionCT) => {
    let nav = navigation;
    if (!hasPV)
        nav = excludeGenerationReport(nav);
    if (!hasESS)
        nav = excludeBatteryReport(nav);
    if (!isConsumptionCT) {
        nav = navigation.filter((nav) => nav.code === NAVIGATION_CODE.generation);
    }
    return nav;
};
const excludeHomeApplianceChart = (navigation) => {
    return navigation.filter((nav) => nav.code !== NAVIGATION_CODE['appliance-chart']);
};
const getFilteredHomeAppliance = (navigation, hasHomeAppliance) => {
    let nav = navigation;
    if (!hasHomeAppliance)
        nav = excludeHomeApplianceChart(nav);
    return nav;
};
export const dashboardNavigation = {
    code: 'dashboard',
    name: 'common.dashboard',
    path: 'Home',
};
export const getReportNavigation = (hasPV, hasESS, isConsumptionCT = true) => ({
    code: 'report',
    name: 'common.report',
    path: isConsumptionCT ? 'Analysis' : 'PvGeneration',
    children: getFilteredReport([
        { code: 'report-analysis', name: 'common.analysis', path: 'Analysis' },
        { code: 'report-pv-generation', name: 'common.production', path: 'PvGeneration' },
        { code: 'report-consumption', name: 'device.consumption', path: 'Consumption' },
        { code: 'report-grid', name: 'device.grid', path: 'Grid' },
        { code: 'report-battery', name: 'device.battery', path: 'Battery' },
    ], hasPV, hasESS, isConsumptionCT),
});
export const ACModuleNavigation = {
    code: 'ac-module',
    name: 'device.ac_module',
    path: 'ACModule',
};
export const getHomeApplianceNavigation = (hasHomeAppliance = true) => ({
    code: 'home-appliance',
    name: 'common.home_appliance',
    path: 'HomeAppliance',
    children: getFilteredHomeAppliance([
        { code: 'home-appliance', name: 'common.home_appliance', path: 'HomeAppliance' },
        { code: 'home-appliance-chart', name: 'common.appliance_chart', path: 'HomeApplianceChart' },
    ], hasHomeAppliance),
});
export const energyManagementNavigation = {
    code: 'energy-management',
    name: 'common.energy_management',
    path: 'EnergyManagement',
};
